module.exports = __webpack_public_path__ + "img/tables-brown.a89bfca1.svg";